import { MutationTree } from 'vuex';

import { SendGridEmailState, SendGridEmailMutations, SendGridEmailSummary } from './types';
import Pagination from '@/store/models/pagination';
import { ListStatus } from '@/store/types';

import SendGridEmail from './sendgrid_email';

export const mutations: MutationTree<SendGridEmailState> = {
  [SendGridEmailMutations.SET_LIST](state, emails: SendGridEmail[]) {
    state.list = emails;
  },
  [SendGridEmailMutations.SET_LIST_PAGINATION](state, pagination: Pagination) {
    state.listPagination = pagination;
  },
  [SendGridEmailMutations.SET_STATUS](state, status: ListStatus) {
    state.status = status;
  },
  [SendGridEmailMutations.SET_SUMMARY](state, summary: SendGridEmailSummary | null) {
    state.summary = summary;
  },
};

export default mutations;
